import React, { useState, useRef, useEffect } from 'react';
import { Play, Square, Loader2 } from 'lucide-react';
import { fetchAudio } from '../../services/api';

// Přehrání TTS audia pro jeden záznam v admin sekci.
// Backend vrátí soubor z cache; pokud audio ještě neexistuje, vygeneruje ho
// (první přehrání pak může chvíli trvat).
const PlayAudioButton = ({ text, speaker = 'am_michael', title = 'Přehrát audio' }) => {
  const [state, setState] = useState('idle'); // idle | loading | playing
  const audioRef = useRef(null);

  const stopAudio = () => {
    if (audioRef.current) {
      audioRef.current.pause();
      URL.revokeObjectURL(audioRef.current.src);
      audioRef.current = null;
    }
  };

  useEffect(() => stopAudio, []);

  const handleClick = async (e) => {
    e.stopPropagation();

    if (state === 'playing') {
      stopAudio();
      setState('idle');
      return;
    }

    try {
      setState('loading');
      // .trim() — stejný klíč cache používá generování audia v adminu
      const blob = await fetchAudio(text.trim(), speaker);
      const audio = new Audio(URL.createObjectURL(blob));
      audioRef.current = audio;
      audio.onended = () => {
        stopAudio();
        setState('idle');
      };
      await audio.play();
      setState('playing');
    } catch (err) {
      console.error('Error playing audio:', err);
      stopAudio();
      setState('idle');
      alert('Nepodařilo se přehrát audio: ' + err.message);
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes play-audio-spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
      <button
        onClick={handleClick}
        disabled={state === 'loading' || !text?.trim()}
        title={state === 'playing' ? 'Zastavit' : title}
        style={{
          width: '28px',
          height: '28px',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          border: 'none',
          borderRadius: '50%',
          cursor: state === 'loading' ? 'wait' : 'pointer',
          backgroundColor: state === 'playing' ? '#dc2626' : '#0891b2',
          color: 'white',
          transition: 'background-color 0.15s ease',
        }}
      >
        {state === 'loading' ? (
          <Loader2 size={14} style={{ animation: 'play-audio-spin 1s linear infinite' }} />
        ) : state === 'playing' ? (
          <Square size={12} fill="currentColor" />
        ) : (
          <Play size={14} fill="currentColor" />
        )}
      </button>
    </>
  );
};

export default PlayAudioButton;
